import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { environment } from '../../../environments/environment';

@Injectable()
export class PageTitleStrategy extends TitleStrategy {
    private titleService = inject(Title);

    override updateTitle(snapshot: RouterStateSnapshot) {
        const title = this.buildTitle(snapshot);
        if (title) {
            this.titleService.setTitle(`${title} - ${environment.appName}`);
        } else {
            this.titleService.setTitle(`${environment.appName}`);
        }
    }
}
